import Typography from "@/components/Typography";
import Button from "@/components/Button";
import Divider from "@/components/Divider";
import styles from "./BottomRow.module.scss";
import { useFormatCurrency } from "@/hooks";
import { CircularProgress } from "@/components/Loader";
import { useTransactionProcessFeesQuery } from "@/fetch/payment";
import cx from "classnames";

const BottomRow: React.FC<{
  isLoading?: boolean;
  isSubmitting?: boolean;
  errorMessage?: string | undefined;
  amount: number | undefined;
  currency: string | undefined;
  currencySymbol: string | undefined;
  buttonText?: string;
  onlyAddCardWithoutPayment: boolean;
}> = ({
  isLoading,
  isSubmitting,
  errorMessage,
  currency,
  amount,
  currencySymbol,
  buttonText,
  onlyAddCardWithoutPayment,
}) => {
  const { format } = useFormatCurrency();

  const hiddenFeeCurrencies = ["GBP", "EUR"];
  const isFeeHidden = Boolean(
    hiddenFeeCurrencies.find((each) => currency === each)
  );

  return (
    <div className={styles.root}>
      {errorMessage && (
        <Typography
          color="error"
          id="payment-message"
          className={styles.message}
        >
          {errorMessage}
        </Typography>
      )}
      <Divider className={styles.divider} />
      <div className={styles.bottomRow}>
        <div style={{ flex: 1 }}>
          {amount !== null && currency !== "" && !onlyAddCardWithoutPayment && (
            <>
              {/* <div style={{ display: "flex", alignItems: "center" }}> */}
              <Typography variant="body2">Your payment today</Typography>

              {/* </div> */}

              <Typography variant="h6">
                {currency} {format(amount, currency, currencySymbol)}
              </Typography>
            </>
          )}
        </div>
        <Button
          endIcon={
            isSubmitting ? <CircularProgress color="inherit" /> : undefined
          }
          type="submit"
          disabled={isLoading || isSubmitting}
          id="submit"
          className={cx({
            [styles.payButton]: !(
              amount !== null &&
              currency !== "" &&
              !onlyAddCardWithoutPayment
            ),
            [styles.addButton]: onlyAddCardWithoutPayment,
          })}
        >
          {buttonText || "Pay"}
        </Button>
      </div>
    </div>
  );
};

export default BottomRow;
